import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceChangePlanzoneNotificationState = createStateReducer(initialState, {
  [events.changePlanzoneFailed]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "changePlanzone",
        flags: ["failure"],
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceChangePlanzoneNotificationState };
